import { render } from "./IndexIbayaq.vue?vue&type=template&id=31fae27b"
import script from "./IndexIbayaq.vue?vue&type=script&lang=js"
export * from "./IndexIbayaq.vue?vue&type=script&lang=js"

import "./IndexIbayaq.vue?vue&type=style&index=0&id=31fae27b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__